import { useEffect } from 'react';
import {
  defaultFeature,
  feature,
  getHeadersUnwrapped,
  IApiCallStatus,
  IFeature,
  useFeatureContext,
  useUserContext,
} from '..';
import { map as emap, left, right } from 'fp-ts/lib/Either';
import { pathOr, reduce } from 'rambda';
import { compose as lcompose } from 'lodash/fp';

export function useFeature({
  apiCallStatus,
}: {
  apiCallStatus: IApiCallStatus;
}) {
  const { setFeature } = useFeatureContext();

  const { user } = useUserContext();
  const headers = getHeadersUnwrapped(user);

  useEffect(() => {
    lcompose(
      emap(() =>
        feature(headers).then(
          lcompose(
            setFeature,
            reduce<
              {
                featureName:
                  | keyof IFeature
                  | 'id-proof-re-enroll'
                  | 'disable-doc-upload'
                  | 'employment-verification';
                toggle: boolean;
              },
              IFeature
            >((prev, current) => {
              prev[
                current.featureName === 'id-proof-re-enroll'
                  ? 'idProofReNnroll'
                  : current.featureName === 'disable-doc-upload'
                  ? 'disableDocUpload'
                  : current.featureName === 'employment-verification'
                  ? 'evs'
                  : current.featureName
              ] = current.toggle;
              return prev;
            }, defaultFeature),
            pathOr([], 'data')
          )
        )
      ),
      apiCallStatus =>
        apiCallStatus ? right(apiCallStatus) : left(apiCallStatus)
    )(apiCallStatus);
  }, [apiCallStatus, headers, setFeature]);
}
